import PropTypes from 'prop-types';
import ArticleActionAnchor from '../articleActionAnchor';
import Icon from '../../icon';
import { PiiArticleEventsPropTypes } from '../../../utils/trackers/createArticleEvents';
import { createEprLink } from '../../../utils/linkCreator';
import { analyticsFormat, analyticsScope, trackAdobeEvent } from '../../../utils/trackers/adobe';

export default function ViewPdfAnchor({
  pii, id, viewPdfEventData, onClick,
}) {
  const memoizedOnClick = () => {
    if (viewPdfEventData) {
      trackAdobeEvent('navigationClick', viewPdfEventData);
    }

    if (onClick) {
      onClick({
        component: 'viewpdf',
        format: analyticsFormat.MIME_PDF,
        scope: analyticsScope.FULL,
      });
    }
  };

  return (
    <ArticleActionAnchor
      icon={<Icon.Pdf height={18} />}
      href={createEprLink({ pii })}
      label="View PDF"
      id={id}
      onClick={memoizedOnClick}
    />
  );
}

ViewPdfAnchor.propTypes = {
  pii: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  viewPdfEventData: PiiArticleEventsPropTypes.viewPdf,
  onClick: PropTypes.func,
};

ViewPdfAnchor.defaultProps = {
  viewPdfEventData: undefined,
  onClick: undefined,
};
